import React from 'react';
import PropTypes from 'prop-types';

const BulkSubscriptions = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_244_4996)">
      <path
        d="M14.25 3H13.5V2.25C13.5 1.83579 13.1642 1.5 12.75 1.5V1.5C12.3358 1.5 12 1.83579 12 2.25V3H6V2.25C6 1.83579 5.66421 1.5 5.25 1.5V1.5C4.83579 1.5 4.5 1.83579 4.5 2.25V3H3.75C2.9175 3 2.2575 3.675 2.2575 4.5L2.25 15C2.25 15.825 2.9175 16.5 3.75 16.5H14.25C15.075 16.5 15.75 15.825 15.75 15V4.5C15.75 3.675 15.075 3 14.25 3ZM14.25 15H3.75V7.5H14.25V15ZM14.25 6H3.75V4.5H14.25V6Z"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <rect
        x="5"
        y="9"
        width="2.5"
        height="2.5"
        rx="0.5"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <rect
        x="5"
        y="12"
        width="2.5"
        height="2.5"
        rx="0.5"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <rect
        x="8"
        y="9"
        width="2.5"
        height="2.5"
        rx="0.5"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <rect
        x="8"
        y="12"
        width="2.5"
        height="2.5"
        rx="0.5"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <rect
        x="11"
        y="9"
        width="2.5"
        height="2.5"
        rx="0.5"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <rect
        x="11"
        y="12"
        width="2.5"
        height="2.5"
        rx="0.5"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
    </g>
    <defs>
      <clipPath id="clip0_244_4996">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

BulkSubscriptions.propTypes = {
  fill: PropTypes.string,
};

export default BulkSubscriptions;
